/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Label_Job_DescriptionInputs */

const en_keyword_optimizer_label_job_description = /** @type {(inputs: Keyword_Optimizer_Label_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Description`)
};

const de_keyword_optimizer_label_job_description = /** @type {(inputs: Keyword_Optimizer_Label_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Description`)
};

const fr_keyword_optimizer_label_job_description = /** @type {(inputs: Keyword_Optimizer_Label_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Description`)
};

const es_keyword_optimizer_label_job_description = /** @type {(inputs: Keyword_Optimizer_Label_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Description`)
};

const it_keyword_optimizer_label_job_description = /** @type {(inputs: Keyword_Optimizer_Label_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Description`)
};

const nl_keyword_optimizer_label_job_description = /** @type {(inputs: Keyword_Optimizer_Label_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Description`)
};

const pl_keyword_optimizer_label_job_description = /** @type {(inputs: Keyword_Optimizer_Label_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Description`)
};

const fi_keyword_optimizer_label_job_description = /** @type {(inputs: Keyword_Optimizer_Label_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Description`)
};

const da_keyword_optimizer_label_job_description = /** @type {(inputs: Keyword_Optimizer_Label_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Description`)
};

const sv_keyword_optimizer_label_job_description = /** @type {(inputs: Keyword_Optimizer_Label_Job_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Description`)
};

/**
* | output |
* | --- |
* | "Job Description" |
*
* @param {Keyword_Optimizer_Label_Job_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_label_job_description = /** @type {((inputs?: Keyword_Optimizer_Label_Job_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Label_Job_DescriptionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_label_job_description(inputs)
	if (locale === "fr") return fr_keyword_optimizer_label_job_description(inputs)
	if (locale === "es") return es_keyword_optimizer_label_job_description(inputs)
	if (locale === "it") return it_keyword_optimizer_label_job_description(inputs)
	if (locale === "nl") return nl_keyword_optimizer_label_job_description(inputs)
	if (locale === "pl") return pl_keyword_optimizer_label_job_description(inputs)
	if (locale === "fi") return fi_keyword_optimizer_label_job_description(inputs)
	if (locale === "da") return da_keyword_optimizer_label_job_description(inputs)
	if (locale === "sv") return sv_keyword_optimizer_label_job_description(inputs)
	return en_keyword_optimizer_label_job_description(inputs)
});